import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useParams } from "react-router-dom";
import { useTranslatedData } from "../data/data.jsx";
import i18next from "i18next";

export const Iframe = ({ page, setInit = false }) => {
  const { tutorialId } = useParams();
  const data = useTranslatedData(); // esto ejecuta t() y devuelve los textos traducidos
  const currentLanguage = i18next.language;

  const isVideo = Boolean(tutorialId);

  if (tutorialId) {
    const {
      options: [{ tutorial }],
    } = data.find((item) => item.id === tutorialId);
    // Usamos /player_iframe (el reproductor Paella directo) en vez de /iframe
    // (una miniatura con botón de play que obligaba a un tap extra para cargar
    // el reproductor). Así el vídeo se reproduce con un solo toque.
    page = `https://canal.uned.es/player_iframe/${tutorial[currentLanguage]}`;
  }

  useEffect(() => {
    setInit(false);

    ReactGA.event({
      category: "Usuario",
      action: `Accede a página: ${page}`,
    });
  }, []);

  return (
    <div className={`iframe${isVideo ? " iframe--video" : ""}`}>
      <iframe
        title="uned-blog"
        loading="lazy"
        src={page}
        frameBorder="0"
        allowFullScreen
      />
    </div>
  );
};
